import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import groupBy from "lodash/groupBy";
import React, { FC, useContext } from "react";

import { css } from "styled-components";

export interface OrderShippedDateStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    orderDate?: TypographyProps;
}

export const orderShippedDateStyles: OrderShippedDateStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = orderShippedDateStyles;

const OrderShippedDate: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.orderLines) {
        return null;
    }

    const shippedLines = order.orderLines?.filter(ol => ol.status === "Shipped");
    const shipments = groupBy(shippedLines, line => line.properties["shippedDate"]);
    const pendingLines = order.orderLines?.filter(ol => ol.status !== "Shipped");
    if (pendingLines && shipments && Object.entries(shipments).length + pendingLines.length !== 1) {
        return null;
    }
    const shippedDate = Object.keys(shipments)[0];

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="shippedDate">
                {translate("Shipped Date")}
            </Typography>
            <Typography {...styles.orderDate} aria-labelledby="shippedDate">
                {shippedDate}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderShippedDate,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
